/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Ios_AppInputs */

const en_common_ios_app = /** @type {(inputs: Common_Ios_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS App`)
};

const es_common_ios_app = /** @type {(inputs: Common_Ios_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App para iOS`)
};

/**
* | output |
* | --- |
* | "iOS App" |
*
* @param {Common_Ios_AppInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_ios_app = /** @type {((inputs?: Common_Ios_AppInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Ios_AppInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_ios_app(inputs)
	return en_common_ios_app(inputs)
});